import { createFileRoute } from "@tanstack/react-router";
import type * as React from "react";

import { ConsoleConnectorDetailPage, consoleConnectorDetailQueryOptions } from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/connectors/$connectionId")({
  loader: ({ context: { queryClient }, params }) => {
    void queryClient.ensureQueryData(consoleConnectorDetailQueryOptions(params.connectionId));
  },
  component: ConnectorDetailRoute,
});

function ConnectorDetailRoute(): React.ReactElement {
  const { connectionId } = Route.useParams();
  return <ConsoleConnectorDetailPage connectionId={connectionId} />;
}
